var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0 11l2-2 5 5L18 3l2 2L7 18z"}})}
var staticRenderFns = []

export { render, staticRenderFns }